import React from 'react';
import DOMPurify from 'dompurify';
// Import Shared components
import {
  ActionBar,
  Button,
  ButtonGroup,
  Alert,
  Modal,
} from 'shared-components';
// Import Component Styles
import { ConfirmBody } from '../components/styles';

export default function({ alert, text, onClick, closeModal }) {
  return <Modal key="confirm-change-modal">
    {alert && <Alert type="warn">{text.alert}</Alert>}
    <ConfirmBody>
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(text.confirmText),
        }}
      />
    </ConfirmBody>
    <ActionBar>
      <ButtonGroup reverse>
        <Button type="danger" size="large" onClick={onClick}>
          {text.buttonText}
        </Button>
        <Button type="secondary" variant="text" onClick={closeModal}>
          Cancel
        </Button>
      </ButtonGroup>
    </ActionBar>
  </Modal>;
};
